/**
 * The palette and fonts of `PayPageGateV1` (its `GATE`), copied rather than imported: templates and
 * screens do not share UI code, so a change to the gate never moves the chat. Same roles as there —
 * `surface` only under the data the client carries to the bank, `mono` for the digits they retype.
 */
export const CHAT = {
  ink: '#333333',
  muted: '#8a8a8a',
  title: 'rgb(121, 121, 121)',
  surface: 'rgb(248, 255, 239)',
  line: '#e0e0e0',
  grey: '#f7f7f7',
  yellow: '#fdf6e3',
  action: '#6aaa3a',
  actionText: 'rgb(92, 138, 30)',
  actionSoft: 'rgb(212, 239, 175)',
  paid: '#93c84a',
  warn: '#b25a2e',
  sans: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  mono: "'PT Mono', monospace",
} as const;

/** `50 000 ₽`, `1 234,50 ₽`. */
export const money = (amount: number): string => {
  const whole = Math.abs(amount - Math.round(amount)) < 0.005;
  const text = amount.toLocaleString('ru-RU', {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 2,
  });
  return `${text.replace(/ | /g, ' ')} ₽`;
};
